import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render international section for FAQ Page
 */
const InternationalSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="international-section-component"
    >
      <AccordionV2
        testId="international"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="Will SCA 'go international' by including companies from other countries?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 mt-2 px-6 py-4 pb-0">
          <p>
            There is no intention to include companies which are not primarily
            listed on the Singapore Exchange.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default InternationalSection;
